import React, { useState } from "react";
import Card from "../../../MyUI/Card/Card";

export default function SignUpPage() {
 

  return (
    <Card title={"Registration"} showChevron={false}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",  // center vertically
        }}
      ></div>
      <div style={{color: "green",
        fontSize: "20px",
        textAlign: "center",}}>
        If the email exists, a verification has been sent! Check your spam folder if you don't see it.
      </div>
    </Card>
  );
}
